import { render, staticRenderFns } from "./LanguageChange.vue?vue&type=template&id=2991a415&scoped=true&"
import script from "./LanguageChange.vue?vue&type=script&lang=js&"
export * from "./LanguageChange.vue?vue&type=script&lang=js&"
import style0 from "./LanguageChange.vue?vue&type=style&index=0&id=2991a415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991a415",
  null
  
)

export default component.exports